import type { Shipment } from "@freightsimple/generated-dashboard-openapi-client/models/Shipment";
import type { ReactNode } from "react";
import { useState } from "react";
import { ChangePickupDateDialog } from "@/Features/ChangePickupDate/Exports/Dialogs/ChangePickupDateDialog";

/**
 * Owns the change-pickup-date dialog for a booked shipment.
 *
 * Two places on the shipment page offer the action — the details section and
 * the additional options menu — and both want identical behaviour, so the
 * dialog is declared once here rather than twice.
 */
export function useViewShipmentsChangePickupDateDialog(
  shipment: Shipment,
  onReload: () => Promise<void>,
): { show: () => void; dialogs: ReactNode } {
  const [open, setOpen] = useState(false);

  const dialogs = (
    <ChangePickupDateDialog
      open={open}
      onOpenChange={(nowOpen) => {
        setOpen(nowOpen);
        // The legacy flow reloaded the shipment whenever the modal closed.
        if (!nowOpen) {
          onReload();
        }
      }}
      shipment={shipment}
    />
  );

  return { show: () => setOpen(true), dialogs };
}
